import React from 'react';
import { useDivisions } from '../../hooks/use-divisions';
import { Card } from '../layout';
import { Badge } from '../ui/badge';

export function DivisionStats() {
  const { data, isLoading } = useDivisions();

  if (isLoading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {[1, 2, 3].map((i) => (
          <Card key={i} className="animate-pulse">
            <div className="h-4 bg-secondary-200 dark:bg-secondary-600 rounded w-1/2 mb-2"></div>
            <div className="h-8 bg-secondary-200 dark:bg-secondary-600 rounded w-1/3"></div>
          </Card>
        ))}
      </div>
    );
  }
  

  const divisions = data?.divisions || [];
  const totalDivisions = divisions.length;
  const activeDivisions = divisions.filter(d => d.active).length;
  const inactiveDivisions = totalDivisions - activeDivisions;

  const stats = [
    {
      label: 'Total Divisions',
      value: totalDivisions,
      badge: totalDivisions > 0 ? 'info' : 'default',
    },
    {
      label: 'Active Divisions',
      value: activeDivisions,
      badge: activeDivisions > 0 ? 'success' : 'default',
    },
    {
      label: 'Inactive Divisions',
      value: inactiveDivisions,
      badge: inactiveDivisions > 0 ? 'warning' : 'default',
    },
  ] as const;

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
      {stats.map((stat) => (
        <Card key={stat.label}>
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-secondary-600 dark:text-secondary-400">
                {stat.label}
              </p>
              <p className="text-2xl font-bold text-secondary-900 dark:text-white">
                {stat.value}
              </p>
            </div>
            <Badge variant={stat.badge} size="lg">
              {stat.value}
            </Badge>
          </div>
        </Card>
      ))}
    </div>
  );
}
